import { __BASE_URL__ } from "../services/http";
import photo from "../icons/avatar.svg";

const getAvatarResourcesUrl = (payload: string | null) =>
  payload ? payload : photo;

export { getAvatarResourcesUrl };
